import MiniTextDetails from './MiniTextDetails';

export default {
    text: MiniTextDetails,
}